import { Dialog,Toast } from 'vant';

export const getUrlparams = (url) => {
  var uId = ''
  if(url.indexOf('?')!=-1){
    uId = url.substr(url.indexOf('?'))
  }
  var obj = {};
//以&为分界切割
  var arr =uId.slice(1,uId.length).split('&');//["id=3", "ab=3", "cd=4"]
//遍历数组
  arr.forEach(function(val){
    //切割=两边的数据
    var arr1 = val.split('=');
    obj[arr1[0]]=arr1[1];
  })
  return obj
}

export const countDownTimeFunc = (downTime)=> {

  var downTimeObj = {
    hour: '00',
    minute: '00',
    second: '00'
  };
  // 倒计时结束
  if (downTime <= 0) {
    return downTimeObj;
  }

  // var d = parseInt(downTime / 1000 / 3600 / 24);
  var h = parseInt(downTime / 1000 / 3600);
  var m = parseInt(downTime / 1000 / 60 % 60);
  var s = parseInt(downTime / 1000 % 60);

  // d < 10 ? d = '0' + d : d;
  h < 10 ? h = '0' + h : h;
  m < 10 ? m = '0' + m : m;
  s < 10 ? s = '0' + s : s;
  downTimeObj.hour=h;
  downTimeObj.minute = m;
  downTimeObj.second = s;
  return downTimeObj;

}

export const getDateTime = (value) => {
  var time = new Date(value*1000);
  var year = time.getFullYear();
  var month = time.getMonth() + 1;
  var date = time.getDate();
  var hour = time.getHours();
  var minute = time.getMinutes();
  var second = time.getSeconds();
  month = month < 10 ? "0" + month : month;
  date = date < 10 ? "0" + date : date;
  hour = hour < 10 ? "0" + hour : hour;
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

export const getDate = (value) => {
  var time = new Date(value);
  var year = time.getFullYear();
  var month = time.getMonth() + 1;
  var date = time.getDate();
  month = month < 10 ? "0" + month : month;
  date = date < 10 ? "0" + date : date;
  return year + "-" + month + "-" + date;
}

export const toCopy = (jsonContent) => {
  if (jsonContent) {
    this.fakeElem = document.createElement('textarea')
    this.fakeElem.value = jsonContent
    this.fakeElem.style.position = 'fixed';
    this.fakeElem.style.top = 0;
    this.fakeElem.style.left = 0;
    this.fakeElem.style.width = '2rem';
    this.fakeElem.style.height = '2rem';
    this.fakeElem.style.padding = 0;
    this.fakeElem.style.border = 'none';
    this.fakeElem.style.outline = 'none';
    this.fakeElem.style.boxShadow = 'none';
    this.fakeElem.style.background = 'transparent';
    document.body.appendChild(this.fakeElem)
    this.fakeElem.select()
    if (document.execCommand('Copy')) {
      Toast.success('复制成功');
    } else {
      this.fakeElem.setSelectionRange(0, this.fakeElem.value.length), document.execCommand('Copy');
      Toast.fail('复制成功');
    }
    if (this.fakeElem) {
      document.body.removeChild(this.fakeElem)
      this.fakeElem = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js